module.exports = __webpack_public_path__ + "4f299f625b962395a6de432791385ba7.png";